// API related actions
export const FETCHING_DAILY_VEHICLES_SALES = '@@toyota/FETCHING_DAILY_VEHICLES_SALES';
export const FETCHED_DAILY_VEHICLES_SALES = '@@toyota/FETCHED_DAILY_VEHICLES_SALES';
export const FETCHED_DAILY_VEHICLES_SALES_FAILED = '@@toyota/FETCHED_DAILY_VEHICLES_SALES_FAILED';
export const DOWNLOADING_DAILY_VEHICLES_SALES = '@@toyota/DOWNLOADING_DAILY_VEHICLES_SALES';
export const DOWNLOADED_DAILY_VEHICLES_SALES = '@@toyota/DOWNLOADED_DAILY_VEHICLES_SALES';
export const DOWNLOADED_DAILY_VEHICLES_SALES_FAILED = '@@toyota/DOWNLOADED_DAILY_VEHICLES_SALES_FAILED';
export const FETCHING_WALK_IN = '@@toyota/FETCHING_WALK_IN';
export const FETCHED_WALK_IN = '@@toyota/FETCHED_WALK_IN';
export const FETCHED_WALK_IN_FAILED = '@@toyota/FETCHED_WALK_IN_FAILED';

// complementary actions
export const CLEAR_URL_IN_DAILY_VEHICLES_SALES = '@@toyota/CLEAR_URL_IN_DAILY_VEHICLES_SALES';
